import Image from 'next/image'

const OtherPageBg = () => {
	return (
		<div className='w-full lg:block hidden h-[400px]'>
			<Image
				fill
				alt='background image'
				src='/other-page-bg.webp'
				className='max-h-[400px] '
			/>
			<p className='font-bold relative pt-[100px] text-center text-[40px] text-[#F1F2F7]  w-full'>
				&quot;Drive Your Journey Today!&quot;
			</p>
		</div>
	)
}

export default OtherPageBg
